<template>
    <rkm-layout-body title="Lista de bloqueio de jornada">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'exame-laboratorial-jornada-bloqueio-create' })"
                authorize="store-exame-laboratorial-jornada-bloqueio"
                color="primary"
            >
                Cadastrar bloqueio de jornada
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/exame-laboratorial/jornada-bloqueio/List'

export default {
    components: {List},
}
</script>